module.exports = __webpack_public_path__ + "img/icon3.31850b80.svg";